module.exports = __webpack_public_path__ + "img/subAra7.db12ecdc.jpg";